import { getDocumentsWithToken } from "@services/azureDataApi";
import { SasTokenPrefix } from "@services/user/types";
import { useMutation } from "@tanstack/react-query";

export const useDownloadLicenseDocument = () => {
  const documentMutation = useMutation({
    mutationFn: async ({ url }: { service: string; url: string }) => {
      return getDocumentsWithToken(url, SasTokenPrefix.LICENSE_SERVICE);
    },
  });

  const handleDownload = async (service: string, documentUrl: string, filename?: string) => {
    try {
      if (!documentUrl) {
        console.error("Document URL is required");
        return;
      }

      const blob = await documentMutation.mutateAsync({ service, url: documentUrl });
      const defaultName = filename || "document.pdf";
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = defaultName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handlePreview = async (service: string, documentUrl: string) => {
    try {
      if (!documentUrl) {
        console.error("Document URL is required");
        return;
      }

      const blob = await documentMutation.mutateAsync({ service, url: documentUrl });
      const objUrl = URL.createObjectURL(blob);
      window.open(objUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Preview failed:", err);
    }
  };

  return {
    handleDownload,
    handlePreview,
    isPending: documentMutation.isPending,
    isError: documentMutation.isError,
    error: documentMutation.error,
  };
};
